import axios from "axios";
import { z } from "zod";

export const qriApi = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: `${import.meta.env.VITE_QRI_SERVICE_HOSTNAME}`,
  withCredentials: true,
});

const QriDetailsResponse = z.record(
  z.string(),
  z.object({ name: z.string() }).passthrough(),
);

export const qriApiClient = {
  /**
   * Resolves QRIs to their resource names. QRIs the caller has no access to, or
   * that no longer exist, are simply absent from the returned map.
   */
  async resolveQriNames(
    qris: readonly string[],
  ): Promise<Record<string, string>> {
    const unique = Array.from(new Set(qris));

    if (!unique.length) {
      return {};
    }

    const response = await qriApi.post("/details", { qris: unique });

    const items = QriDetailsResponse.parse(response.data);

    return Object.fromEntries(
      Object.entries(items).map(([qri, item]) => [qri, item.name]),
    );
  },
} as const;
